/* assets/pr-card-pc.js
   Animación de entrada para las cards .pc-anim[data-pc-anim].
   - Funciona con contenido cargado después (tabs lazy, "load more", Flickity)
     porque observa el DOM con MutationObserver.
   - Respeta "reducir movimiento": en ese caso no oculta nada. */
(function () {
  if (window.__pcAnimInit) return;
  window.__pcAnimInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window) || !('MutationObserver' in window)) return;

  document.documentElement.classList.add('pc-anim-ready');

  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  var io = new IntersectionObserver(function (entries) {
    var batch = 0;
    entries.forEach(function (entry) {
      var el = entry.target;
      var once = el.getAttribute('data-pc-once') !== 'false';
      var stagger = parseInt(el.getAttribute('data-pc-stagger'), 10) || 0;

      if (entry.isIntersecting) {
        el.style.transitionDelay = (batch * stagger) + 'ms';
        batch++;
        el.classList.add('is-visible');
        if (once) io.unobserve(el);
      } else if (!once) {
        el.style.transitionDelay = '0ms';
        el.classList.remove('is-visible');
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  function observe(el) {
    if (seen) {
      if (seen.has(el)) return;
      seen.add(el);
    }
    io.observe(el);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.hasAttribute && node.hasAttribute('data-pc-anim')) observe(node);
    var found = node.querySelectorAll ? node.querySelectorAll('[data-pc-anim]') : [];
    for (var i = 0; i < found.length; i++) observe(found[i]);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) scan(m.addedNodes[i]);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document.body); });
  } else {
    scan(document.body);
  }
})();
